import React from 'react';
import { Modal, Button, Row, Col, Badge } from 'react-bootstrap';

const renderTravelDetails = (travel) => {
  if (!travel) return null;

  const mode = travel.mode_of_transport || travel.modeOfTransport || travel.mode || null;
  const distance = travel.distance_km != null ? travel.distance_km : (travel.distanceKm != null ? travel.distanceKm : travel.distance);
  const merchant = travel.merchant || travel.vendor || null;

  const parseLoc = (loc) => {
    if (!loc) return null;
    if (typeof loc === 'string') return { name: loc, address: '' };
    const name = loc.name || loc.place_name || loc.formattedAddress || loc.formatted_address || '';
    const address = loc.formattedAddress || loc.formatted_address || loc.address || '';
    return {
      name,
      address: address !== name ? address : ''
    };
  };

  const startLoc = parseLoc(travel.start_location || travel.startLocation);
  const endLoc = parseLoc(travel.end_location || travel.endLocation);
  const stops = Array.isArray(travel.stops) ? travel.stops.map(parseLoc).filter(Boolean) : [];

  const getTransportIcon = (m) => {
    if (!m) return 'fa-car';
    const lower = String(m).toLowerCase();
    if (lower.includes('bike') || lower.includes('motorcycle') || lower.includes('two wheeler')) return 'fa-motorcycle';
    if (lower.includes('auto') || lower.includes('rickshaw')) return 'fa-taxi';
    if (lower.includes('bus')) return 'fa-bus';
    if (lower.includes('cab') || lower.includes('taxi')) return 'fa-taxi';
    if (lower.includes('train') || lower.includes('rail') || lower.includes('public')) return 'fa-train';
    if (lower.includes('flight') || lower.includes('plane')) return 'fa-plane';
    return 'fa-car';
  };

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)', 
      border: '1px solid #bae6fd', 
      borderRadius: '12px', 
      padding: '16px', 
      marginBottom: '20px' 
    }}>
      <div style={{ 
        fontSize: '12px', 
        fontWeight: 800, 
        color: '#0369a1', 
        textTransform: 'uppercase', 
        letterSpacing: '.04em', 
        marginBottom: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
      }}>
        <i className="fa fa-map-signs" style={{ fontSize: '14px', color: '#0284c7' }}></i> Travel & Commute Details
      </div>

      {/* Highlights Bar */}
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: (startLoc || endLoc) ? '14px' : '0' }}>
        {mode && (
          <div style={{ 
            background: '#ffffff', 
            border: '1px solid #93c5fd', 
            borderRadius: '8px', 
            padding: '6px 12px', 
            fontSize: '12.5px', 
            fontWeight: 700, 
            color: '#1e40af',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
          }}>
            <i className={`fa ${getTransportIcon(mode)}`} style={{ color: '#2563eb' }}></i>
            <span>{mode}</span>
          </div>
        )}

        {distance != null && (
          <div style={{ 
            background: '#ffffff', 
            border: '1px solid #86efac', 
            borderRadius: '8px', 
            padding: '6px 12px', 
            fontSize: '12.5px', 
            fontWeight: 700, 
            color: '#166534',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
          }}>
            <i className="fa fa-road" style={{ color: '#16a34a' }}></i>
            <span>{Number(distance).toLocaleString('en-IN')} KM</span>
          </div>
        )}

        {merchant && (
          <div style={{ 
            background: '#ffffff', 
            border: '1px solid #fde68a', 
            borderRadius: '8px', 
            padding: '6px 12px', 
            fontSize: '12.5px', 
            fontWeight: 700, 
            color: '#854d0e',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
          }}>
            <i className="fa fa-shopping-bag" style={{ color: '#d97706' }}></i>
            <span>Merchant/Vendor: <strong>{merchant}</strong></span>
          </div>
        )}
      </div>

      {/* Route Timeline */}
      {(startLoc || endLoc) && (
        <div style={{ background: '#ffffff', borderRadius: '10px', padding: '14px', border: '1px solid #e0f2fe', boxShadow: '0 1px 4px rgba(0,0,0,0.02)' }}>
          <div style={{ fontSize: '11px', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.03em', marginBottom: '12px' }}>
            Route & Commute Path
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {/* Start Location */}
            {startLoc && (
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <div style={{ 
                  width: '22px', 
                  height: '22px', 
                  borderRadius: '50%', 
                  background: '#dcfce7', 
                  color: '#15803d', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  fontSize: '10px',
                  fontWeight: 800,
                  flexShrink: 0,
                  marginTop: '1px',
                  border: '1px solid #86efac'
                }}>
                  🟢
                </div>
                <div>
                  <div style={{ fontSize: '13px', fontWeight: 700, color: '#0f172a' }}>
                    <span style={{ fontSize: '11px', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginRight: '4px' }}>Start Location:</span>
                    {startLoc.name || startLoc.address}
                  </div>
                  {startLoc.address && startLoc.address !== startLoc.name && (
                    <div style={{ fontSize: '11.5px', color: '#64748b', marginTop: '2px' }}>
                      <i className="fa fa-map-marker text-muted mr-1"></i>{startLoc.address}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Intermediate Stops */}
            {stops.map((stop, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <div style={{ 
                  width: '22px', 
                  height: '22px', 
                  borderRadius: '50%', 
                  background: '#fef3c7', 
                  color: '#b45309', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  fontSize: '10px',
                  fontWeight: 800,
                  flexShrink: 0,
                  marginTop: '1px',
                  border: '1px solid #fde68a'
                }}>
                  🟡
                </div>
                <div>
                  <div style={{ fontSize: '13px', fontWeight: 700, color: '#0f172a' }}>
                    <span style={{ fontSize: '11px', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginRight: '4px' }}>Stop #{idx + 1}:</span>
                    {stop.name || stop.address}
                  </div>
                  {stop.address && stop.address !== stop.name && (
                    <div style={{ fontSize: '11.5px', color: '#64748b', marginTop: '2px' }}>
                      <i className="fa fa-map-marker text-muted mr-1"></i>{stop.address}
                    </div>
                  )}
                </div>
              </div>
            ))}

            {/* Destination Location */}
            {endLoc && (
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <div style={{ 
                  width: '22px', 
                  height: '22px', 
                  borderRadius: '50%', 
                  background: '#fee2e2', 
                  color: '#b91c1c', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  fontSize: '10px',
                  fontWeight: 800,
                  flexShrink: 0,
                  marginTop: '1px',
                  border: '1px solid #fca5a5'
                }}>
                  🔴
                </div>
                <div>
                  <div style={{ fontSize: '13px', fontWeight: 700, color: '#0f172a' }}>
                    <span style={{ fontSize: '11px', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginRight: '4px' }}>Destination:</span>
                    {endLoc.name || endLoc.address}
                  </div>
                  {endLoc.address && endLoc.address !== endLoc.name && (
                    <div style={{ fontSize: '11.5px', color: '#64748b', marginTop: '2px' }}>
                      <i className="fa fa-map-marker text-muted mr-1"></i>{endLoc.address}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const ExpenseDetailModal = ({ item, onClose, onUpdateStatus, reportingToName, isAdmin = true }) => {
  if (!item) return null;

  const currentStatus = (item.approvalStatus || item.approval_status || 'pending').toUpperCase();
  const repName = reportingToName || item.reportingToName || item.reporting_to_name || (typeof item.reporting_to === 'object' ? item.reporting_to?.name : null);
  const approverName = item.approved_by_name || (typeof item.approved_by === 'object' ? (item.approved_by?.name || item.approved_by?.username) : item.approved_by);
  const proofUrls = item.proof_urls || (item.bill_url ? [item.bill_url] : []) || [];
  const travelDetails = item.travel_details || item.travelDetails || item.travel;

  return (
    <Modal show={true} onHide={onClose} centered size="lg">
      <Modal.Header closeButton style={{ borderBottom: '1px solid #f1f5f9', padding: '18px 24px' }}>
        <Modal.Title style={{ fontWeight: 800, color: '#1e293b', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <i className="fa fa-receipt text-primary"></i> Expense Details & Approvals
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: '24px' }}>
        {/* Top Highlight Cards */}
        <Row className="mb-4">
          <Col md={6} xs={12} className="mb-2 mb-md-0">
            <div style={{ background: '#f8fafc', padding: '16px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
              <div style={{ fontSize: '11px', color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em' }}>Amount</div>
              <div style={{ fontSize: '24px', fontWeight: 900, color: '#00b894', marginTop: '4px' }}>
                ₹ {Number(item.amount || 0).toLocaleString('en-IN')}
              </div>
            </div>
          </Col>
          <Col md={6} xs={12}>
            <div style={{ background: '#f8fafc', padding: '16px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
              <div style={{ fontSize: '11px', color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em' }}>Category</div>
              <div style={{ fontSize: '18px', fontWeight: 800, color: '#0284c7', marginTop: '4px' }}>
                {item.category || item.rawCategory || 'Expense'}
              </div>
            </div>
          </Col>
        </Row>

        {/* Details Grid */}
        <Row className="mb-4" style={{ rowGap: '14px' }}>
          <Col md={6} sm={12}>
            <div style={{ fontSize: '13px', color: '#475569', marginBottom: '8px' }}>
              <strong style={{ color: '#1e293b' }}>Date:</strong>{' '}
              {item.date ? new Date(item.date).toLocaleDateString('en-IN') : '—'}
            </div>
            <div style={{ fontSize: '13px', color: '#475569', marginBottom: '8px' }}>
              <strong style={{ color: '#1e293b' }}>Expensed By:</strong>{' '}
              <span style={{ background: '#f1f5f9', color: '#1e293b', padding: '3px 8px', borderRadius: '6px', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                <span>{item.memberName || item.user_name || item.expensed_by || 'Staff'}</span>
                {(item.user_employee_id || item.employee_id || item.paid_by_employee_id || item.created_by_employee_id) && (
                  <span style={{ fontSize: '11px', fontFamily: 'monospace', fontWeight: 700, color: '#2563eb', background: '#eff6ff', padding: '1px 6px', borderRadius: '3px', border: '1px solid #bfdbfe' }}>
                    {item.user_employee_id || item.employee_id || item.paid_by_employee_id || item.created_by_employee_id}
                  </span>
                )}
              </span>
            </div>
            <div style={{ fontSize: '13px', color: '#475569', marginBottom: '8px' }}>
              <strong style={{ color: '#1e293b' }}>Reporting To:</strong>{' '}
              {repName ? (
                <span style={{ 
                  background: '#f8fafc', 
                  color: '#334155', 
                  padding: '3px 8px', 
                  borderRadius: '6px', 
                  fontWeight: 600, 
                  border: '1px solid #e2e8f0',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '5px'
                }}>
                  <i className="fa fa-user-circle-o" style={{ color: '#64748b' }}></i>
                  {repName}
                </span>
              ) : (
                <span style={{ color: '#94a3b8' }}>—</span>
              )}
            </div>
          </Col>

          <Col md={6} sm={12}>
            <div style={{ fontSize: '13px', color: '#475569', marginBottom: '8px' }}>
              <strong style={{ color: '#1e293b' }}>Approval Status:</strong>{' '}
              <Badge 
                style={{
                  padding: '5px 10px',
                  borderRadius: '6px',
                  fontSize: '11px',
                  fontWeight: 700,
                  background: currentStatus === 'APPROVED' ? '#dcfce7' : currentStatus === 'REJECTED' ? '#fee2e2' : '#fef3c7',
                  color: currentStatus === 'APPROVED' ? '#15803d' : currentStatus === 'REJECTED' ? '#b91c1c' : '#b45309',
                  border: currentStatus === 'APPROVED' ? '1px solid #86efac' : currentStatus === 'REJECTED' ? '1px solid #fca5a5' : '1px solid #fde68a'
                }}
              >
                {currentStatus === 'APPROVED' ? '✓ APPROVED' : currentStatus === 'REJECTED' ? '✕ REJECTED' : '⏳ PENDING'}
              </Badge>
            </div>
            {approverName && (
              <div style={{ fontSize: '12.5px', color: '#64748b', marginBottom: '6px' }}>
                <strong style={{ color: '#1e293b' }}>Reviewed by:</strong> {approverName}
              </div>
            )}
            {item.approval_comment && (
              <div style={{ fontSize: '12.5px', color: '#64748b', fontStyle: 'italic', marginBottom: '6px' }}>
                <strong style={{ color: '#1e293b' }}>Comment:</strong> "{item.approval_comment}"
              </div>
            )}
            <div style={{ fontSize: '13px', color: '#475569' }}>
              <strong style={{ color: '#1e293b' }}>Notes/Remarks:</strong>{' '}
              {item.comment || item.remarks || item.notes || item.details || 'None'}
            </div>
          </Col>
        </Row>

        {/* Travel Details Card (if category is TRAVEL or travel_details exist) */}
        {renderTravelDetails(travelDetails)}

        {/* Quick Status Management Panel */}
        {isAdmin && (
          <div style={{ background: '#f8fafc', padding: '16px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '20px' }}>
            <div style={{ fontSize: '12px', fontWeight: 800, color: '#334155', textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: '10px' }}>
              Change Approval Status
            </div>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <Button
                size="sm"
                style={{ background: '#16a34a', borderColor: '#16a34a', fontWeight: 700, padding: '6px 16px', borderRadius: '8px' }}
                onClick={() => { onUpdateStatus(item.id, 'approved'); onClose(); }}
              >
                <i className="fa fa-check mr-1"></i> Mark Approved
              </Button>
              <Button
                size="sm"
                style={{ background: '#dc2626', borderColor: '#dc2626', fontWeight: 700, padding: '6px 16px', borderRadius: '8px' }}
                onClick={() => { onUpdateStatus(item.id, 'rejected'); onClose(); }}
              >
                <i className="fa fa-times mr-1"></i> Mark Rejected
              </Button>
              <Button
                size="sm"
                variant="outline-secondary"
                style={{ fontWeight: 700, padding: '6px 16px', borderRadius: '8px' }}
                onClick={() => { onUpdateStatus(item.id, 'pending'); onClose(); }}
              >
                <i className="fa fa-undo mr-1"></i> Reset to Pending
              </Button>
            </div>
          </div>
        )}

        {/* Receipts & Proofs */}
        {proofUrls.length > 0 ? (
          <div>
            <div style={{ fontSize: '12px', fontWeight: 800, color: '#334155', textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: '12px' }}>
              Receipts & Proof Attachments ({proofUrls.length})
            </div>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              {proofUrls.map((url, idx) => (
                <a key={idx} href={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  <img
                    src={url}
                    alt={`receipt-${idx}`}
                    style={{
                      width: '110px',
                      height: '110px',
                      objectFit: 'cover',
                      borderRadius: '10px',
                      border: '1px solid #cbd5e1',
                      transition: 'transform 0.2s ease',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                    }}
                    onMouseOver={e => e.currentTarget.style.transform = 'scale(1.05)'}
                    onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
                  />
                </a>
              ))}
            </div>
          </div>
        ) : (
          <div style={{ fontSize: '12.5px', color: '#94a3b8' }}>
            <i className="fa fa-paperclip mr-1"></i> No receipts attached to this expense.
          </div>
        )}
      </Modal.Body>

      <Modal.Footer style={{ borderTop: '1px solid #f1f5f9', padding: '14px 24px' }}>
        <Button variant="secondary" onClick={onClose} style={{ borderRadius: '8px', fontWeight: 600, padding: '6px 18px' }}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExpenseDetailModal;
